module.exports = __webpack_public_path__ + "img/news.49c9842b.png";